const PromoCodes = require("../components/PromoCodes");
const { connect } = require("react-redux");
const { fetchPromoCodes } = require("actions/promocodes");

module.exports = connect(
    state => ({
        isFetching: state.promocodes.isFetching,
        items: state.promocodes.items,
        hasFetchedAll: state.promocodes.hasFetchedAll
    }),
    { fetchPromoCodes }
)(PromoCodes);



// WEBPACK FOOTER //
// ./src/routes/admin-promocodes/containers/PromoCodes.js